// eslint-disable-next-line jsdoc/require-jsdoc
export function mergeOptions(base, override) {
    // merge options
    const options = {
        filter: override.filter
            ? { ...base.filter, ...override.filter }
            : base.filter,
        unzip: override.unzip ? { ...base.unzip, ...override.unzip } : base.unzip,
        ungzip: override.ungzip
            ? { ...base.ungzip, ...override.ungzip }
            : base.ungzip,
        logger: override.logger ?? base.logger,
    };
    // remove undefined values
    if (!options.filter) {
        delete options.filter;
    }
    else if (typeof options.filter.ignoreDotfiles !== 'boolean') {
        delete options.filter.ignoreDotfiles;
    }
    if (!options.unzip) {
        delete options.unzip;
    }
    else {
        if (typeof options.unzip.recursive !== 'boolean') {
            delete options.unzip.recursive;
        }
        if (!options.unzip.zipExtensions)
            delete options.unzip.zipExtensions;
    }
    if (!options.ungzip) {
        delete options.ungzip;
    }
    else if (!options.ungzip.gzipExtensions) {
        delete options.ungzip.gzipExtensions;
    }
    if (!options.logger)
        delete options.logger;
    return options;
}
export const defaultOptions = {
    filter: {
        ignoreDotfiles: true,
    },
    ungzip: {
        gzipExtensions: ['gz'],
    },
    unzip: {
        zipExtensions: ['zip'],
        recursive: true,
    },
};
//# sourceMappingURL=Options.js.map